import androidx.compose.runtime.Composable
import io.github.dautovicharis.charts.app.MainScreen

@Composable
internal fun JsMainScreen() {
    MainScreen()
}
